<template>
  <div id="home" class="flex">
    <!-- Modal -->
    <Modal :open="open" @close="open = false">
      <div class="max-w-2xl w-full bg-white rounded-lg shadow-2xl px-6 py-2">
        <h1
          class="text-3xl tracking-wider text-center mb-8"
        >Enter your name and email address below to join the FREE challenge!</h1>
        <form action="/about" class="mx-auto max-w-sm" method="GET">
          <label class="block" for="username">First Name</label>
          <input
            name="firstname"
            class="shadow appearance-none border w-full py-2 px-3 focus:outline-none focus:shadow-outline mb-2"
            id="first-name"
            type="text"
            placeholder="First Name"
          />
          <label class="block" for="username">Email</label>
          <input
            name="email"
            class="shadow appearance-none border w-full py-2 px-3 focus:outline-none focus:shadow-outline mb-2"
            id="email"
            type="text"
            placeholder="Email Address"
          />
          <p class="text-lg mb-2">
            This form collects information we will use to send you updates about
            promotions, special offers, and news. We will not share or sell your
            personal information. You can unsubscribe at any time.
          </p>
          <a href="#" class="block underline mb-2">Privacy Policy</a>
          <div class="mb-2">
            <input class="mr-2 leading-tight" type="checkbox" />
            <span class="text-lg">Send me your newsletter!</span>
          </div>
          <button
            type="submit"
            @click="open = false"
            class="px-4 py-2 w-full text-white font-semibold bg-mine-light hover:bg-mine-primary border border-transparent rounded focus:outline-none focus:shadow-outline tracking-widest text-xl"
          >Join The Challenge</button>
        </form>
        <div class="text-center text-sm text-gray-700 mt-6">
          <p>
            Privacy Policy: We hate spam and promise to keep your email address
            safe
          </p>
        </div>
      </div>
    </Modal>
    <div>
      <!-- Login Button -->
      <button
        type="button"
        @click="open = true"
        class="absolute mb-5 lg:mb-0 bg-white text-blue-700 hover:bg-mine-primary hover:text-white font-bold py-2 px-4 rounded tracking-widest font-bold text-lg border-2 border-blue-700 fixed z-30 right-0 top-0 mt-4 mr-4 bg-gray-100"
      >Login</button>
      <!-- Intro Section -->
      <section id="intro" class="bg-gray-100">
        <div class="container mx-auto py-20">
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 pl-8 lg:pl-12 py-10 pr-8 md:pr-2">
              <img src="@/assets/images/logo.png" class="w-72 h-12 object-fill mb-10" />
              <h1
                class="text-3xl lg:text-5xl font-extrabold tracking-wider leading-none mb-8"
              >Go From Idea to Desirable Digital Product!</h1>
              <p class="tracking-wider text-xl font-light mb-8">
                Start the FREE 72-Hour Idea to Product Challenge, &amp; Get
                Step-by-Step Instructions daily to Help You Test Your Digital Product Idea,
                Start from nothing. Quickly build a landing page and email funnel
                to gather customer interest and focus on the right product, 
                start helping others and building your dream business.
              </p>
              <button
                type="button"
                @click="open = true"
                class="w-full md:w-auto mb-5 lg:mb-0 bg-mine-light hover:bg-mine-primary text-white font-bold py-2 px-4 md:px-12 rounded tracking-widest font-bold text-xl md:text-lg lg:text-xl"
              >I'm ready to launch my dream!</button>
            </div>
            <div class="w-full md:w-1/2 lg:pt-32 pr-4 lg:pr-12 pl-4 md:pl-2 md:pt-32">
              <img src="@/assets/images/no-cache-Computer-Mockup.jpg" class="px-8 sm:px-0 w-full" />
            </div>
          </div>
        </div>
      </section>
      <!-- Video Section -->
      <section id="video" class="my-10">
        <h2 class="text-center text-2xl tracking-wide font-semibold mt-16 mb-16 text-gray-800 mx-8">
          Your first steps to realizing your dream will be emailed to you IMMEDIATELY after
          you subscribe. (And then daily after that.)
        </h2>
        <div class="mx-2 mt-4">
          <iframe
            class="m-auto max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl h-64 sm:h-80 px-8"
            width="800"
            src="https://www.youtube-nocookie.com/embed/9i_WVm5LPSc"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </section>
      <!-- References -->
      <section id="references" class="bg-gray-100 pt-20 pb-10">
        <h2
          class="text-center text-4xl tracking-widest font-black mx-6"
        >Gain More Focus and Clarity before you Build!</h2>
        <div class="container mx-auto">
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 px-10">
              <TwitterCard
                name="SpicoTech"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
              <TwitterCard
                name="MailChimp"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
              <TwitterCard
                name="Google"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
            </div>
            <div class="w-full md:w-1/2 px-10">
              <TwitterCard
                name="Jon Smith"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
              <TwitterCard
                name="Jon Doe"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
              <TwitterCard
                name="Jane Doe"
                message="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce aliquam fermentum dui ac dapibus. Suspendisse vestibulum mattis semper. Praesent tortor nisi, laoreet et leo a, aliquam mollis metus. Cras mauris elit, commodo ac mollis scelerisque, ornare quis odio. Aliquam fringilla elit ac magna laoreet facilisis. Quisque varius vestibulum tellus a."
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            @click="open = true"
            class="bg-mine-light hover:bg-mine-primary text-white font-bold py-2 px-4 md:px-16 rounded tracking-widest font-bold text-xl"
          >I'm ready to launch my dream!</button>
        </div>
      </section>
      <!-- Instructor -->
      <section id="instructor" class="my-30">
        <div class="container mx-auto py-20">
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 pl-8 lg:pt-20 lg:pl-12 pr-8 md:pr-4">
              <h3 class="text-xl tracking-wider">ABOUT THE INSTRUCTOR</h3>
              <h2
                class="text-3xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider font-black text-blue-700 leading-tight"
              >Kevin Johnson PhD</h2>
              <h4 class="text-xl tracking-widest mb-4">Passion-based Entreprenuer</h4>
              <p class="tracking-tight text-gray-900">
                "One of the biggest mistakes I made when starting my company was
                NOT testing the market before building. Since then, I've
                learned my lesson and have always started new businesses by first
                gaining customer feedback. Gain traction FIRST,
                before launching a product! Build a landing page in 1 day and 
                start collecting emails of interested customers.
              </p>
            </div>
            <div class="md:w-1/2 pr-8 mt-2 mx-auto md:mx-0 w-auto lg:pt-16 pl-4">
              <img src="@/assets/images/no-cache-instructor.jpg" class="w-64 md:w-full lg:w-96" />
            </div>
          </div>
        </div>
      </section>
      <!-- Jumbotron -->
      <section id="jumbotron" class="bg-gray-900 py-20 px-10 lg:px-32">
        <h2
          class="text-center text-3xl md:text-5xl text-white font-black px-4 md:px-32 md:tracking-wide mb-4"
        >Sign up now! Your first steps to launching your dream are ready for you...</h2>
        <div class="text-center mb-5">
          <button
            type="button"
            @click="open = true"
            class="mb-5 lg:mb-0 bg-mine-light hover:bg-mine-primary text-white font-bold py-2 px-4 md:px-16 rounded tracking-widest font-bold text-xl"
          >I'm ready to launch my dream!</button>
        </div>
      </section>
      <!-- footer -->
      <footer id="footer" class="mt-8 mb-4 text-gray-700">
        <p class="text-center">&copy;2020 kevinjohnsonphd, LLC All rights reserved.</p>
        <!-- <p class="text-center"> -->
          <!-- <a href="#" class="underline hover:no-underline">Privacy Policy</a> | -->
          <!-- <a href="#" class="underline hover:no-underline">Terms of Use</a> -->
        <!-- </p> -->
      </footer>
    </div>
  </div>
</template>

<script>
import TwitterCard from "@/components/twitterCard.vue";
import Modal from "@/components/Modal.vue";
export default {
  name: "Home",
  components: {
    TwitterCard,
    Modal
  },
  data() {
    return {
      open: false
    };
  }
};
</script>
